'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'diamond-half-stroke';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M61.3 256L272 466.7 272 45.3 61.3 256z', 'M16 256L38.6 278.6 265.4 505.4 288 528 560 256 537.4 233.4 310.6 6.6 288-16 265.4 6.6 38.6 233.4 16 256zM272 466.7L61.3 256 272 45.3 272 466.7zm32 0L304 45.3 514.7 256 304 466.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;